import React from 'react';

import { useField, useFormikContext } from 'formik';
import { Autocomplete, TextField } from '@mui/material';

import { SelectOption } from 'src/models';

interface Props {
  id: string;
  options: SelectOption[];
  label: string;
  disabled?: boolean;
  team?: SelectOption;
}

const AutocompleteWrapper = ({
  id,
  options,
  label,
  disabled,
  team,
}: Props): JSX.Element => {
  const { setFieldValue } = useFormikContext<{}>();
  const [, meta] = useField<{}>(id);

  return (
    <Autocomplete
      disablePortal={true}
      id={id}
      options={options}
      getOptionLabel={(option) =>
        option.homeTeam
          ? `${option.name} (Top Seed)`
          : `${option.name} (Lower Seed)`
      }
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={(e, value) => {
        setFieldValue(id, value);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={!!(meta.touched && meta.error)}
        />
      )}
      value={team}
      disabled={disabled}
    />
  );
};

export default AutocompleteWrapper;
